import { Box, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export default function ModuleHeader({ module, title, onBack }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5, mb: 3 }}>
      <Box>
        <Typography sx={{ color: '#00F1A7', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', fontSize: 12, mb: 0.5 }}>
          {module}
        </Typography>
        <Typography variant="h1" sx={{ fontSize: { xs: '1.8rem', md: '2.4rem' }, lineHeight: 1.2, fontWeight: 800 }}>
          {title}
        </Typography>
      </Box>
      <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => (onBack ? onBack() : navigate(-1))}
        sx={{ borderColor: 'rgba(0,241,167,0.4)', color: '#00F1A7', fontWeight: 700, borderRadius: 1, px: 2.5 }}>
        Voltar
      </Button>
    </Box>
  );
}
